import { render, staticRenderFns } from "./zsgzlc.vue?vue&type=template&id=6a3112e8&scoped=true"
import script from "./zsgzlc.vue?vue&type=script&lang=js"
export * from "./zsgzlc.vue?vue&type=script&lang=js"
import style0 from "./zsgzlc.vue?vue&type=style&index=0&id=6a3112e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3112e8",
  null
  
)

export default component.exports